import React from "react";
import { Button } from "react-bootstrap";

/**
 * The buttons that end every Manager create and edit form (#309): Cancel, then the form's own
 * action, on the right. Each form used to lay them out itself, so Create Contest and Create Auction
 * read [Cancel][Save], Add Sport and Add Team [Save][Cancel], and Update Contest put [Update][Cancel]
 * on the left, in two different button sizes.
 *
 * @param {object} props
 * @param {() => void} props.onCancel Called by Cancel.
 * @param {string} [props.submitLabel] The submit button's text: "Save" on Add, "Update" on Update.
 * @param {boolean} [props.disabled] Disables the submit button (a save or an upload on its way).
 * @param {string} [props.form] The form's id, for buttons rendered outside it (a modal footer).
 * @param {string} [props.className] Extra classes for the row.
 */
export const FormActions = ({ onCancel, submitLabel = "Save", disabled = false, form, className = "" }) => (
  <div className={`form-actions ${className}`.trim()}>
    <Button type="button" className="btn-Cancel secondary" onClick={onCancel}>
      Cancel
    </Button>
    <Button type="submit" form={form} className="btn-Save" disabled={disabled}>
      {submitLabel}
    </Button>
  </div>
);
